<template>
  <div>
    <div>
      <a-menu style="width: 256px" mode="horizontal" @click="handleClick">
        <a-sub-menu v-for="(fatherItem, index) in father" :key="index" @titleClick="titleClick">
          <span slot="title">
            <a-icon type="mail" />
            <span>{{ fatherItem }}</span>
          </span>
          <a-menu-item-group v-if="children.length > 0" key="channel">
            <a-menu-item v-for="(childItem, i) in children" :key="i" @click="handleClick"> {{ childItem }}</a-menu-item>
          </a-menu-item-group>
        </a-sub-menu>
      </a-menu>
    </div>

    <div style="background: #fafafa; padding: 16px">
      <am-editor :content="detail" model="view" :drag="false" />
    </div>
  </div>
</template>
<script>
import { promptList, promptDetail } from '@/api/event/problem';
import AmEditor from '@/components/AmEditor/index';

export default {
  components: { AmEditor },
  data() {
    return {
      channel: '',
      step: '',
      father: [],
      children: [],
      detail: ''
    };
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      promptList({ channel: this.channel, step: this.step }).then(res => {
        if (this.channel === '') {
          this.father = res.data;
        } else {
          this.children = res.data;
        }
      });
    },
    getDetail() {
      promptDetail({ channel: this.channel, step: this.step }).then(res => {
        this.detail = res.data[0];
      });
    },
    handleClick(e) {
      this.step = e.key;
      this.getDetail();
    },
    titleClick(e) {
      this.channel = e.key;
      this.getData();
    }
  }
};
</script>
